/**
 * Normally component Hopper sends us here after storing parameters "returnKeys" in appStore
 * If user visits this url directly ("/form") we don't have "returnKeys" and notify the user what to do
 * Ask them for their email and send them link(s) with parameters ("/form/nr/code/key") for their application(s)
 */



// import { useMutation } from '@tanstack/react-query'
import { useAppStore } from '../store/appStore';

// import { Typography, Select } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

// import { orange } from '@mui/material/colors';
// import { ISubmitResponse } from '../lib/interfaces/models'
import RAppForm from '../returnforms/RAppForm';


/////////////////////////////////////
export const ReturnPage = () => {
  const returnKeys = useAppStore(state => state.returnKeys)

  return (

    <Grid container sx={{ pt: 1, backgroundColor: '#FAFAFA' }}>

      <Grid xs={12}>
        <RAppForm />
      </Grid>

    </Grid>
  )
}
